import { LanguageService } from './../../../Services/languageService';
import { Subscription } from 'rxjs';
import { userService } from './../../../Services/userService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { renewPolicyModel } from '../../../Models/policyModel';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import { mdlBindInfoCompRenewalRes } from '../../../Models/mdlBindInfoCompRenewalRes';
import { mdlBindInfoCompRenewalReq } from '../../../Models/mdlBindInfoCompRenewalReq';
import { mdlPremiumAndVehicleInfoCompRenewalRes } from '../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { mdlRenewalPolicies } from '../../../Models/mdlRenewalPolicies';
import { MotorDriverMdl } from '../../../Models/MotorDriverMdl';



@Component({
    selector: 'CompRenewalPolicy',
    templateUrl: './CompRenewalPolicy.html',
    styleUrls: ['./CompRenewalPolicy.css']
})
export class CompRenewalPolicy {

    public isShowLoading: boolean = false;
    public renewObj: renewPolicyModel = new renewPolicyModel();
   // public renewObj :mdlRenewalPolicies=new mdlRenewalPolicies();
   
    public st: MotorStatusMdl = new MotorStatusMdl();
    public subscription: Subscription;
    public LngSubscription: Subscription;
    public Lng: string;
    public RegNo: string;
    public objBindInfoRes: mdlBindInfoCompRenewalRes = new mdlBindInfoCompRenewalRes();
    public bindObjReq: mdlBindInfoCompRenewalReq = new mdlBindInfoCompRenewalReq();
    public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();

    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
    public ToDate: Date;
    public diverObj: MotorDriverMdl = new MotorDriverMdl();

    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService, private lngService: LanguageService) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        this.renewObj = JSON.parse(sessionStorage.getItem("renewObj"));
       // this.renewObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("RenewalPolicy")));

        //this.renewObj.PrdCode=='5520'
        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }

        this.bindInfo();


    }
    bindInfo() {
        sessionStorage.removeItem("objPremiumAndVehicleInfoRes");
        sessionStorage.removeItem("objAddProposalRes");
        sessionStorage.removeItem("PaymentType");
        sessionStorage.removeItem("ScreenShot");
        sessionStorage.removeItem("objmdlPayFortRequestDetailsRes");
        sessionStorage.removeItem("PROPOSALNO");
        sessionStorage.removeItem("objBindInfoRes");


        this.bindObjReq.PolicyNo = this.renewObj.PolicyNo;
        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.bindObjReq));

        //this.http.post<mdlBindInfoCompRenewalRes>(this.url.baseURL + "/Comp_Renewal/BindInfo", this.bindObjReq, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Comp_Renewal/BindInfo", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;

                //New Line Start
                this.objPayloadResponse = result;
                this.objBindInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End
                

                if (this.objBindInfoRes.StatusCode == '1') {


                    //this.objBindInfoRes = result;

                    if (this.objBindInfoRes.MaxSumInsured == 0 || this.objBindInfoRes.MinSumInsured == 0) {
                        this.objBindInfoRes.MaxSumInsured = 999999;
                        this.objBindInfoRes.MinSumInsured = 1;
                    }
                    if (this.objBindInfoRes.SumInsured < this.objBindInfoRes.MinSumInsured || this.objBindInfoRes.SumInsured > this.objBindInfoRes.MaxSumInsured) {
                        this.objBindInfoRes.SumInsured = null;
                    }

                } else {
                    if (this.objBindInfoRes.ErrorMsg != null) {
                        Swal(this.objBindInfoRes.ErrorMsg);
                    }
                    else {
                        Swal("Details Not Found/Already Renewed/Another Proposal Exists");
                    }
                    this.isShowLoading = false;
                    this.router.navigate(['/NewDashboard/Policy']);

                }

            },
                (error) => {
                    this.isShowLoading = false;
                    this.userinfo.checkTokenStatus(error);

                });
    }


    ValidateSpecialChar(event) {
        var k;
        k = event.charCode;
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }


    proceedToRenew(valid) {

        this.RegNo = sessionStorage.getItem("RegNo");
        this.objBindInfoRes.RegNo = this.RegNo;
        //sessionStorage.setItem("objBindInfoRes", JSON.stringify(this.objBindInfoRes));
        sessionStorage.setItem("objBindInfoRes", this.EncriptService.EncriptObject(JSON.stringify(this.objBindInfoRes)));
        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objBindInfoRes));

        //this.http.post<mdlPremiumAndVehicleInfoCompRenewalRes>(this.url.baseURL + "/Comp_Renewal/GetPremiumAndVehicleCompRenewal", this.objBindInfoRes, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Comp_Renewal/GetPremiumAndVehicleCompRenewal", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                //this.objPremiumAndVehicleInfoRes = result;

                //New Line Start
                this.objPayloadResponse = result;
                this.objPremiumAndVehicleInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End 


                if (this.objPremiumAndVehicleInfoRes.StatusCode == '0') {
                    Swal(this.objPremiumAndVehicleInfoRes.ErrorMsg);
                    return;
                }
                // this.ToDate = new Date(this.objPremiumAndVehicleInfoRes.VEHICLE_INFO.PROPOSAL_EXPIRYDATE);
                // this.ToDate.setDate(this.ToDate.getDate() + 60);
                // this.objPremiumAndVehicleInfoRes.VEHICLE_INFO.PROPOSAL_EXPIRYDATE = this.GetDate(this.ToDate);

                //this.objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode = '5520';
                //sessionStorage.setItem("objPremiumAndVehicleInfoRes", JSON.stringify(this.objPremiumAndVehicleInfoRes));
                sessionStorage.setItem("objPremiumAndVehicleInfoRes", this.EncriptService.EncriptObject(JSON.stringify(this.objPremiumAndVehicleInfoRes)));
                this.router.navigate(['NewDashboard/CompRenewalProposal/CompRenewalPremiumInfo']);
            }, (error) => {
                this.isShowLoading = false;
                this.userinfo.checkTokenStatus(error);

            });


    }

    Cancel() {
        this.router.navigate(['/NewDashboard/Policy']);
    }

    GetDate(val): string {
      
        var d = new Date(val),
            month = '' + (d.getMonth() + 1),
            day = '' + (d.getDate()),
            year = '' + (d.getFullYear());

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return year + "-" + month + "-" + day;
    
    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalPolicy/CompRenewalPolicy.ts